export { default } from './CompactList';



// WEBPACK FOOTER //
// ./app/components/shared/CompactList/index.js